import { isApiNotFoundStatus } from '../../../utils/api'
import { getRentalPortalApplicantIdentityLabel } from '../../RentalPortalApplicant'

export function getApplicantProfileTitle({ applicantData, t }) {
  return applicantData
    ? getRentalPortalApplicantIdentityLabel({ applicant: applicantData, t })
    : null
}

export function getHasApplicantProfileLoadFailed({
  applicantData,
  isInitiated,
  serverError,
}) {
  return Boolean(serverError) || (isInitiated && !applicantData)
}

export function getIsApplicantProfileNotFound(serverError) {
  return isApiNotFoundStatus(serverError?.status)
}

export function getIsApplicantClosed(applicantData) {
  return Boolean(
    applicantData?.archived ||
    applicantData?.phase?.is_terminal ||
    applicantData?.terminal_at
  )
}
